<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { exportPostsUrl } from "./api";

const router = useRouter();
const oneYearAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().slice(0, 10);
const today = new Date().toISOString().slice(0, 10);
const duration = ref("custom"), postStartDate = ref(oneYearAgo), postEndDate = ref(today);

const durationItems = [
  { title: "All", value: "all_time" },
  { title: "Last month", value: "last_month" },
  { title: "Last year", value: "last_year" },
  { title: "Custom", value: "custom" },
];
const link = computed(() => exportPostsUrl({ duration: duration.value, post_start_date: postStartDate.value, post_end_date: postEndDate.value }));
</script>

<template>
  <section>
    <VBtn variant="text" prepend-icon="mdi:arrow-left" class="mb-4" @click="router.push({ name: 'posts' })">Back</VBtn>
    <h1 class="text-h5 mb-4">Export Posts</h1>
    <VCard class="pa-4" max-width="480">
      <VSelect v-model="duration" label="Posts Date Range" :items="durationItems" item-title="title" item-value="value" class="mb-4" />
      <VRow v-if="duration === 'custom'" class="mb-4">
        <VCol cols="6"><VTextField v-model="postStartDate" label="Start Date" type="date" /></VCol>
        <VCol cols="6"><VTextField v-model="postEndDate" label="End Date" type="date" /></VCol>
      </VRow>
      <VBtn :href="link" target="_blank" rel="noopener" prepend-icon="mdi:download">Export</VBtn>
    </VCard>
  </section>
</template>
